import React, { Fragment, useState, useEffect } from 'react';
import { Tabs, Tab, Box, Grid, TextField, Button, Paper, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { useStyles } from './LoginDetailsStyles';
import {post} from "../utils/OctoberApiUtils";
import formValidation from "../utils/FormValidation";

import { ReactComponent as CheckmarkSvg } from '../assets/check-icon.svg';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box width={1/2}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function LoginDetails({ classes, setIsAuthenticated }) {
  const [tabValue, setTabValue] = useState(0);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [loginError, setLoginError] = useState(false);
  const [consentTerms, setConsentTerms] = useState(false);
  const [consentPromo, setConsentPromo] = useState(false);
  const loginClasses = useStyles();

  const fieldsValidation = {
    userRegistrationName: {
      error: "",
      validate: "text",
      minLength: 2,
      maxLength: 20
    },
    userRegistrationEmail: {
      error: "",
      validate: "email"
    },
    userLoginEmail: {
      error: "",
      validate: "email"
    }
  }

  console.log(formErrors);

  const registrationIsValid =
    name.length > 0 &&
    !formErrors.userRegistrationName &&
    email.length > 0 &&
    !formErrors.userRegistrationEmail &&
    password.length > 0 &&
    !formErrors.userRegistrationPassword;

  const loginIsValid = email.length > 0 && !formErrors.userLoginEmail && password.length > 0 && !formErrors.userLoginPassword;

  const handleTabs = (event, newValue) => {
    setTabValue(newValue);
  };

  const login = async () => {
    try {
      const response = await post('/api/react/auth/login', {email, password});
      if(response.data.userId>0){
        setIsAuthenticated(true);
      }
    } catch (error) {
      setLoginError(true);
      setTimeout( () => {
        setLoginError(false);
      }, 5000);
      console.error(`Cannot login, error`, error);
    }
  };

  const register = async () => {
    if(consentTerms) {
      try {
        const response = await post('/api/react/auth/register', {email, password, name, consentTerms, consentPromo});
        if(response.data.emailIsTaken===1){
          alert("Adresa de e-mail introdusă este deja folosită. Te rugăm să te loghezi sau să introduci o altă adresă de e-mail.");
        }
        if(response.data.userId>0){
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error(`Cannot register user , error`, error);
      }
    } else {
      alert('Te rugăm să accepți termenii de utilizare!');
    }
  };

  const handleEmailChange = e => {
    setEmail(e.target.value);
      const error = formValidation(e.target.name, e.target.value, fieldsValidation) || ''
      setFormErrors(prevErrors => ({
        ...prevErrors,
        [e.target.name]: error
      }))
  }
  const handlePasswordChange = e => {
    setPassword(e.target.value);
    if(e.target.value.length < 8) {
      setFormErrors(prevErrors => ({
        ...prevErrors,
        [e.target.name]: 'Parola trebuie sa contina minim 8 caractere.'
      }))
    } else {
      setFormErrors(prevErrors => ({
        ...prevErrors,
        [e.target.name]: ''
      }))
    }
  }
  const handleNameChange = e => {
    setName(e.target.value);
    if(e.target.name === 'userRegistrationName') {
      const error = formValidation(e.target.name, e.target.value, fieldsValidation) || ''
      setFormErrors(prevErrors => ({
        ...prevErrors,
        [e.target.name]: error
      }))
    }
  }

  const handleConsentTerms = () => {
    setConsentTerms(!consentTerms);
  };

  const handleConsentPromo = () => {
    setConsentPromo(!consentPromo);
  };

  return (
    <Fragment>
      <Paper square elevation={0} className={loginClasses.loginMessage}>
        <Typography>Obține <span>linkul</span> după <span>autentificare *</span></Typography>
      </Paper>
      <Tabs
        className={loginClasses.tabsContainer}
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleTabs}
        aria-label="login and registration tabs"
      >
        <Tab className={loginClasses.tab} label="Cont nou" />
        <Tab className={loginClasses.tab} label="Login" />
      </Tabs>
      <TabPanel value={tabValue} index={0} className={classes.inputContainer}>
        <Grid container>
          <Grid item xs={12} className={classes.noPadding}>
            <Paper square elevation={0} className={classes.inputTitleContainer}>
              <Typography className={classes.inputTitleText}>Nume *</Typography>
            </Paper>
            <TextField
              className={classes.inputFieldContainer}
              fullWidth
              margin="normal"
              placeholder="Nume"
              name="userRegistrationName"
              onChange={handleNameChange}
              value={name}
              error={!!formErrors.userRegistrationName}
              helperText={formErrors.userRegistrationName}
            />
          </Grid>
          <Grid item xs={12} className={classes.noPadding}>
            <Paper square elevation={0} className={classes.inputTitleContainer}>
              <Typography className={classes.inputTitleText}>Email *</Typography>
            </Paper>
            <TextField
              className={classes.inputFieldContainer}
              fullWidth
              margin="normal"
              placeholder="Email"
              name="userRegistrationEmail"
              onChange={handleEmailChange}
              value={email}
              error={!!formErrors.userRegistrationEmail}
              helperText={formErrors.userRegistrationEmail}
            />
          </Grid>
          <Grid item xs={12} className={classes.noPadding}>
            <Paper square elevation={0} className={classes.inputTitleContainer}>
              <Typography className={classes.inputTitleText}>Parola *</Typography>
            </Paper>
            <TextField
              className={classes.inputFieldContainer}
              fullWidth
              type="password"
              pattern=".{8,}"
              margin="normal"
              placeholder="Parola, minim 8 caractere"
              name="userRegistrationPassword"
              onChange={handlePasswordChange}
              value={password}
              error={!!formErrors.userRegistrationPassword}
              helperText={formErrors.userRegistrationPassword}
            />
          </Grid>
          <Grid item xs={12} className={classes.noPadding}>
            <FormControlLabel
              required
              className={`${classes.checkbox} login`}
              control={
                <Checkbox
                  checked={consentTerms}
                  onChange={handleConsentTerms}
                  name="consentTerms"
                  color="primary"
                  checkedIcon={<CheckmarkSvg />}
                />
              }
              label={<label>Am citit și sunt de acord cu <a href='/termeni-si-conditii' target="_blank"> Termeni și condiții.</a></label>}
            />
            <FormControlLabel
              className={`${classes.checkbox} login`}
              control={
                <Checkbox
                  checked={consentPromo}
                  onChange={handleConsentPromo}
                  name="consentPromo"
                  color="primary"
                  checkedIcon={<CheckmarkSvg />}
                />
              }
              label="Sunt de acord cu primirea de materiale de marketing."
            />
          </Grid>
          <Button variant="contained" color="primary" className={`${classes.nextButton} ${loginClasses.continueBtn}`} onClick={register} disabled={!registrationIsValid}>
              Continuă
            <ChevronRightIcon />
          </Button>
        </Grid>
      </TabPanel>
      <TabPanel value={tabValue} index={1} className={classes.inputContainer}>
        <Grid container>
          <Grid item xs={12} className={classes.noPadding}>
            <Paper square elevation={0} className={classes.inputTitleContainer}>
              <Typography className={classes.inputTitleText}>Email *</Typography>
            </Paper>
            <TextField
              className={classes.inputFieldContainer}
              fullWidth
              margin="normal"
              placeholder="Email"
              name="userLoginEmail"
              onChange={handleEmailChange}
              value={email}
              error={!!formErrors.userLoginEmail}
              helperText={formErrors.userLoginEmail}
            />
          </Grid>
          <Grid item xs={12} className={classes.noPadding}>
            <Paper square elevation={0} className={classes.inputTitleContainer}>
              <Typography className={classes.inputTitleText}>Parola *</Typography>
            </Paper>
            <TextField
              className={classes.inputFieldContainer}
              fullWidth
              type="password"
              margin="normal"
              placeholder="Parola"
              name="userLoginPassword"
              onChange={handlePasswordChange}
              value={password}
              error={!!formErrors.userLoginPassword}
              helperText={formErrors.userLoginPassword}
            />
          </Grid>
          { loginError &&
            <span className={loginClasses.loginError}>Adresa de email sau parola nu este corecta.</span>
          }
          <Button variant="contained" color="primary" className={`${classes.nextButton} ${loginClasses.continueBtn}`} onClick={login} disabled={!loginIsValid}>
              Continuă
            <ChevronRightIcon />
          </Button>
        </Grid>
      </TabPanel>
    </Fragment>
  );
}
